module.exports = __webpack_public_path__ + "static/lite-graphic-128ebe3bc2a701983fb969c9a73dbb52.svg";